export function formatPrice(price, fractionDigits, lang, currency) {
    if (!Number.isInteger(fractionDigits)) {
        throw new Error("Fraction digits must be integer");
    }
    if (fractionDigits < 0) {
        const pow = Math.pow(10, -fractionDigits);
        price = Math.round(price / pow) * pow;
        fractionDigits = 0;
    }
    return new Intl.NumberFormat(lang, {
        style: "currency",
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(price);
}
